import { render, staticRenderFns } from "./CommissionsSavingForm.vue?vue&type=template&id=d6c772b2&"
import script from "./CommissionsSavingForm.vue?vue&type=script&lang=js&"
export * from "./CommissionsSavingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports